import React from 'react';
import { gridToWorld } from './facilityCoords';

/**
 * Flat corridor walkway slab.
 * @param {object} corridorDef - a CORRIDORS entry from facilityLayout.js
 */
export function CorridorMesh({ corridorDef }) {
  const { x, y, z, boxW, boxH, boxD } = gridToWorld({
    col: corridorDef.col,
    row: corridorDef.row,
    w: corridorDef.w,
    h: corridorDef.h,
    type: undefined, // signals corridor mode in gridToWorld
  });

  return (
    <mesh position={[x, y, z]} receiveShadow>
      <boxGeometry args={[boxW, boxH, boxD]} />
      <meshStandardMaterial
        color="#1b201e"
        roughness={0.95}
        metalness={0.0}
      />
    </mesh>
  );
}
